import { styled } from '@styles/theme'

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 180px 1fr;
  grid-gap: ${({ theme }) => theme.spacing(3)};
`
